import { TmrSimpleAttributesMap } from 'stylewhere/api'
import { Box, Card, ProductInfoBox, LabelTag } from 'stylewhere/components'
import { T, __ } from 'stylewhere/i18n'

interface Props {
  attributes?: TmrSimpleAttributesMap[]
  labels?: string[]
  title?: string
}

export const ItemAttributesCard = ({ attributes, labels, title = 'Item' }: Props) => {
  const hasAttributes = Array.isArray(attributes) && attributes.length > 0
  const hasLabels = !!labels && labels.length > 0
  if (!hasAttributes && !hasLabels) return null

  return (
    <Card mb={10} flex title={title}>
      {attributes?.map((attribute) => (
        <ProductInfoBox.Field key={attribute.label} label={attribute.label} value={attribute.value} />
      ))}
      {hasLabels && (
        <ProductInfoBox.Field
          label={__(T.fields.labels)}
          value={
            <Box flex row style={{ flexWrap: 'wrap', gap: 8 }}>
              {labels.map((label, index) => (
                <LabelTag key={`${label}-${index}`} text={label} />
              ))}
            </Box>
          }
        />
      )}
    </Card>
  )
}
